(function () {
    var vimeoBands = null;
    var vimeoOnPage = false;

    function IEVersion() {
        var sAgent = window.navigator.userAgent;
        var Idx = sAgent.indexOf("MSIE");

        // If IE, return version number.
        if (Idx > 0)
            return parseInt(
                sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx))
            );
        // If IE 11 then look for Updated user agent string.
        else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;
        else return 0; //It is not IE
    }

    function patchBands() {
        var bands = $(".band--height-expanded, .band--height-full");

        // force specific height value on bands to allow IE11 to correctly
        // flex align items
        bands.each(function () {
            var height = $(this).outerHeight();

            $(this).css("height", height);
        });
    }

    function setBandBackGroundVideos(vimeoBands, isInit = false) {
        vimeoBands.forEach(function (band) {
            var iframeContainer = band.querySelector(".iframe-container");
            var iframe = band.querySelector(".iframe-container iframe");
            var vimeoPlayer = new Vimeo.Player(iframe);

            vimeoPlayer.getVideoWidth().then(function (width) {
                vimeoPlayer.getVideoHeight().then(function (height) {
                    var videoContainer = band.querySelector(
                        ".band__video-container"
                    );
                    videoContainer.style = "";
                    iframe.style = "";
                    var vimeoPlayerAspectRatio = null;
                    var bandHeight = getFullWidthOrHeight(band, "height");
                    var bandWidth = getFullWidthOrHeight(band, "width");
                    var bandAspectRatio = bandWidth / bandHeight;
                    var videoContainerWidth = getFullWidthOrHeight(
                        videoContainer,
                        "width"
                    );
                    var videoContainerHeight = getFullWidthOrHeight(
                        videoContainer,
                        "height"
                    );
                    var posterImage = band.querySelector(".poster-image");

                    vimeoPlayerAspectRatio = width / height;
                    var extraHeight = null;
                    var extraWidth = null;
                    var marginTop = 0;
                    var marginLeft = 0;

                    // The bigger the aspect ratio number (width/height) the wider it is than tall.
                    // If the Vimeo video aspect ratio is larger than the band aspect ratio then the height of the vimeo video
                    // will need to be pushed to the height of the band and the width of the vimeo video will be pushed past the
                    // full width of the band. This is the first if statement.
                    // If smaller it will be the opposite, pushing the width to the width of the band and pushing the height past
                    // the height of the band. This is the else statement.

                    if (bandAspectRatio < vimeoPlayerAspectRatio) {
                        var newWidth = bandHeight * vimeoPlayerAspectRatio;
                        extraWidth = newWidth - videoContainerWidth;
                        // I don't understand why this shouldn't be extraWidth/2, but it's not centered when this is done
                        // Setting it to this extarWidth centers the video. I've stopped asking questions at this point. 🤷‍
                        marginLeft = extraWidth;
                        iframe.style.height = bandHeight + "px";
                        iframe.style.width = newWidth + "px";
                        videoContainer.style.width = newWidth + "px";
                    } else {
                        var newHeight = bandWidth * vimeoPlayerAspectRatio;
                        extraHeight = newHeight - videoContainerHeight;
                        marginTop = extraHeight;
                        iframe.style.width = bandWidth + "px";
                        iframe.style.height = newHeight + "px";
                        videoContainer.style.height = newHeight + "px";
                    }

                    iframe.style.marginTop = "-" + marginTop + "px";
                    iframe.style.marginLeft = "-" + marginLeft + "px";

                    if (window.innerWidth > 820 && window.innerHeight > 600) {
                        if (isInit) {
                            vimeoPlayer.play();
                            iframeContainer.style.visibility = "visible";
                        }

                        if (posterImage === null) {
                            return true;
                        }

                        window.setTimeout(function () {
                            posterImage.style.opacity = 0;
                            // we remove to avoid some flashing that happens on phones when you scroll which triggers a
                            // resize event, or something
                            posterImage.remove();
                        }, 500);
                    } else {
                        vimeoPlayer.pause();
                    }
                });
            });
        });
    }

    function initVideoBands() {
        var pause_button = $(".toggle__video");
        vimeoBands = document.querySelectorAll(".band--vimeo");
        vimeoOnPage = vimeoBands !== null;

        if (vimeoOnPage) {
            setBandBackGroundVideos(vimeoBands, true);
        }

        // Event for clicking video pause buttons
        // Only applies to video bands
        pause_button.on("click", function () {
            var video = $(this).prev().children();
            var label = $(this);
            video =
                !vimeoOnPage === null
                    ? document.getElementById(video.attr("id"))
                    : new Vimeo.Player(video);

            // Play or pause video
            // Update text to match state
            if ($(this).hasClass("toggle__video--paused")) {
                label.removeClass("toggle__video--paused");
                label.text("Pause Video");
                // video.play();
            } else {
                label.addClass("toggle__video--paused");
                label.text("Play Video");
                video.pause();
            }
        });
    }

    $(window).on("load", function () {
        initVideoBands();

        if (IEVersion() == 11) {
            patchBands();
        }
    });

    function getFullWidthOrHeight(
        element,
        widthOrHeight,
        elementSetBoxSizing = true
    ) {
        // Get the computed style of the element
        var style = window.getComputedStyle(element);
        let result = null;

        if (widthOrHeight === "width") {
            // Extract the width, padding, and margin properties
            var width = parseFloat(style.width);
            var paddingLeft = 0;
            var paddingRight = 0;

            if (!elementSetBoxSizing) {
                paddingLeft = parseFloat(style.paddingLeft);
                paddingRight = parseFloat(style.paddingRight);
            }
            var marginLeft = parseFloat(style.marginLeft);
            var marginRight = parseFloat(style.marginRight);

            // Calculate the full width, including padding and margin
            result =
                width + paddingLeft + paddingRight + marginLeft + marginRight;
        } else {
            var paddingTop = 0;
            var paddingBottom = 0;

            // Extract the height, padding, and margin properties
            var height = parseFloat(style.height);

            if (!elementSetBoxSizing) {
                paddingTop = parseFloat(style.paddingTop);
                paddingBottom = parseFloat(style.paddingBottom);
            }
            var marginTop = parseFloat(style.marginTop);
            var marginBottom = parseFloat(style.marginBottom);
            // Calculate the full height, including padding and margin
            result =
                height + paddingTop + paddingBottom + marginTop + marginBottom;
        }

        return result;
    }

    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                func.apply(context, args);
            }, wait);
        };
    }

    const debouncedOnResizeHandler = debounce(function () {
        if (vimeoOnPage) {
            setBandBackGroundVideos(vimeoBands);

            if (IEVersion() == 11) {
                patchBands();
            }
        }
    }, 500);

    window.addEventListener("resize", debouncedOnResizeHandler);
})(this);
